import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LeHookPuissant from "./sections/LeHookPuissant";
import ExceptionalRefuge from "./sections/ExceptionalRefuge";
import OurVisualSpecialties from "./sections/OurVisualSpecialties";
import ManageYourPracticeWithClarity from "./sections/ManageYourPracticeWithClarity";
import Portfolio from "./sections/Portfolio";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import CommencezVotreProjet from "./sections/CommencezVotreProjet";
import PiedDePage from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LeHookPuissant />
      <ExceptionalRefuge />
      <OurVisualSpecialties />
      <ManageYourPracticeWithClarity />
      <Portfolio />
      <FrequentlyAskedQuestions />
      <CommencezVotreProjet />
      <PiedDePage />
    </div>;
}